import styled, { css } from 'styled-components';

import { Flex } from 'components/flex';
import { flexSpaceBetween } from 'styles';
import { ListCard } from 'components/list-card';
import { ButtonWithRef } from 'components/button';
import { Placeholder } from 'components/placeholder';
import { captionSemibold } from 'styles/mixins/fonts';

export const StyledButton = styled(ButtonWithRef)<{ hasUnreadCount?: boolean }>`
  margin-right: 8px;
  ${({ theme, hasUnreadCount }) =>
    hasUnreadCount &&
    css`
      position: relative;
      &::before {
        content: '';
        top: 0;
        right: 0;
        width: 6px;
        height: 6px;
        z-index: 10;
        position: absolute;
        border-radius: 50%;
        background-color: ${theme.colors.red.primary.standard};
      }
    `}
`;

export const Title = styled.h4`
  min-width: 0;
  overflow-wrap: anywhere;
  color: ${({ theme }) => theme.colors.grey.primary.standard};
`;

export const Message = styled.p`
  overflow-wrap: anywhere;
  min-width: 0;
`;

export const Actions = styled(Flex)`
  flex-shrink: 0;
`;

export const Container = styled.div`
  display: flex;
  height: 336px;
  flex-direction: column;
  width: ${({ theme }) => `${theme.responsive.isMobile ? 240 : 280}px`};
`;

export const Content = styled.div`
  height: 100%;
  overflow-y: auto;
`;

export const Time = styled.p`
  min-width: 0;
  overflow-wrap: anywhere;
  ${captionSemibold};
  color: ${({ theme }) => theme.colors.grey.primary.standard};
`;

export const StyledListCard = styled(ListCard)<{ showDivider?: boolean }>`
  min-width: 0;
  & > * {
    min-width: 0;
  }
  border-radius: unset;
  ${({ theme, showDivider }) =>
    showDivider &&
    css`
      border-top: 1px solid ${theme.config.border};
    `}
`;

export const UnreadDot = styled.span`
  width: 8px;
  height: 8px;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.blue.primary.standard};
`;

export const Header = styled.div<{ isDialog?: boolean }>`
  ${flexSpaceBetween};
  padding: ${({ isDialog }) => (isDialog ? '8px 8px 0' : '8px 24px')};
`;

export const StyledPlaceholder = styled(Placeholder)`
  padding: 16px;
`;
